var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0032 10.4268C15.8895 10.4268 15.7804 10.4718 15.7 10.5522C15.6197 10.6326 15.5745 10.7417 15.5746 10.8555V11.2842V11.284C15.5746 13.1031 14.8519 14.8477 13.5656 16.1341C12.2795 17.4203 10.5349 18.1429 8.71595 18.1429C6.89695 18.1429 5.15233 17.4203 3.86625 16.1341C2.57996 14.8478 1.8573 13.1033 1.8573 11.284C1.8573 9.46513 2.57996 7.72057 3.86625 6.43435C5.1524 5.14806 6.89695 4.42555 8.71595 4.42555H10.6818L8.84153 6.26585V6.26571C8.75944 6.3458 8.71279 6.45531 8.71207 6.56998C8.71136 6.68452 8.75657 6.79475 8.83766 6.87584C8.91875 6.95679 9.02884 7.002 9.14352 7.00128C9.25805 7.00056 9.36771 6.95406 9.44765 6.87196L12.0197 4.29996C12.1871 4.13247 12.1871 3.86122 12.0197 3.6937L9.44765 1.1217C9.27972 0.957939 9.01118 0.959658 8.8454 1.12558C8.67948 1.29149 8.67776 1.55988 8.84152 1.72798L10.6818 3.56813H8.71593C6.66954 3.56813 4.70692 4.38107 3.25998 5.82812C1.81294 7.27516 1 9.23775 1 11.2841C1 13.3305 1.81294 15.2931 3.25998 16.74C4.70703 18.1871 6.66961 19 8.71593 19C10.7623 19 12.7249 18.1871 14.1719 16.74C15.6189 15.293 16.4319 13.3304 16.4319 11.2841V10.8554V10.8555C16.4319 10.7417 16.3868 10.6326 16.3064 10.5522C16.226 10.4718 16.117 10.4268 16.0031 10.4268L16.0032 10.4268Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/round.15a6addab454bee5eec57451c51d516c.svg";
export { ForwardRef as ReactComponent };